// extracted by mini-css-extract-plugin
export var orderDetails = "_tp-2";
export var orderImage = "_tp-1";
export var orderMeta = "_tp-3";
export var orderSummary = "_tp-0";
export var rightArrow = "_tp-4";